/** The open editor's save, so leaving it from outside (taking a call) loses nothing. */
let save: (() => Promise<void>) | null = null;

export function registerOpenEditor(fn: (() => Promise<void>) | null): void {
  save = fn;
}

export async function saveOpenEditor(): Promise<void> {
  try {
    await save?.();
  } catch {
    // The editor shows its own save errors; the call still goes ahead.
  }
}
